import { render } from "./HeadCarousel.vue?vue&type=template&id=b53913f0"
import script from "./HeadCarousel.vue?vue&type=script&lang=js"
export * from "./HeadCarousel.vue?vue&type=script&lang=js"
script.render = render

export default script